<template>
	<b-navbar-nav class="referral-header-dropdown">
		<b-nav-item-dropdown right no-caret menu-class="referral-menu" toggle-class="referral-toggle">
			<template #button-content>
				<font-awesome-icon icon="gift" />
			</template>
			<div class="referral-card">
				<div class="title">
					Refer Fareclock To Your Network.
					<span class="highlight"> Get A Reward.</span>
				</div>
				<p class="description">
					If you know anyone who could use a hand with their team management, introduce us!
					Receive a <strong>USD $100 gift card</strong> reward for every successful sign-up.
				</p>
				<div class="actions">
					<b-button class="btn-learn" @click="launchLearnMore">Learn More</b-button>
					<b-button class="btn-question" @click="launchQuestion">I have a question</b-button>
				</div>
			</div>
		</b-nav-item-dropdown>
	</b-navbar-nav>
</template>

<script>

export default {
	name: 'ReferralHeaderDropdown',
	methods: {
		launchLearnMore () {
			window.open('https://www.fareclock.com/referral-program', '_blank', 'noopener')
		},
		launchQuestion () {
			const email = 'marketing@fareclock.com'
			const subject = encodeURIComponent('Inquiry About Fareclock\'s Referral Program')
			window.location.href = `mailto:${email}?subject=${subject}`
		},
	},
}
</script>

<style scoped>
.referral-header-dropdown :deep(.dropdown-menu.referral-menu) {
	width: min(30rem, 90vw);
	padding: 0.5rem;
}

.referral-card {
	background: #e6e7e9;
	color: var(--primary-dark-blue);
	text-align: center;
	padding: 1.1rem;
}

.title {
	margin: 0;
	font-weight: 700;
  font-size: 16px;
}

.highlight {
	color: var(--primary-orange);
}

.description {
	margin: 1rem auto 0;
	max-width: 34rem;
	line-height: 1.45;
}

.actions {
	margin-top: 1rem;
	display: flex;
	justify-content: center;
	gap: 1rem;
	flex-wrap: wrap;
}

.actions .btn {
	border: none;
	font-size: 1rem;
	font-weight: 700;
	line-height: 1;
	padding: 0.75rem 1.5rem;
  flex: 1;
  margin: 0;
  white-space: nowrap;
}

.btn-learn {
	background: var(--primary-dark-blue);
	color: #ffffff;
}

.btn-learn:hover,
.btn-learn:focus {
	background: var(--primary-blue-shade-4);
	color: #ffffff;
}

.btn-question {
	background: var(--primary-orange);
	color: #ffffff;
}

.btn-question:hover,
.btn-question:focus {
	background: var(--primary-orange-shade-4);
	color: #ffffff;
}

.fa-gift {
	font-size: 20px;
}

@media (max-width: 576px) {
	.referral-card {
		padding: 1rem;
	}

	.actions {
		gap: 0.75rem;
	}

	.actions .btn {
		width: 100%;
	}
}
</style>
